import Resource from './resource';
import Page from './page';
import removeGpsDeviceCaptureProjection, { isMissingGpsDeviceCaptureColumnError } from '../lib/sql-utils';

export default class Query extends Resource {
  async ast(params) {
    const options = {
      method: 'POST',
      url: `${this.client.config.query_url}/api/v2/query`,
      qs: {
        // wl : nonsense query parameter to signal to use a dedicated
        // workload for a performance experiment
        wl: 1,
      },
      body: {
        ...params,
        ast: true,
        format: 'json',
      },
    };

    const body = await this.client.call(options);

    return JSON.parse(body);
  }

  async run(params) {
    const options = {
      method: 'POST',
      url: `${this.client.config.query_url}/api/v2/query`,
      qs: {
        // wl : nonsense query parameter to signal to use a dedicated
        // workload for a performance experiment
        wl: 1,
      },
      body: {
        ...params,
        arrays: 1,
        format: 'json',
      },
    };

    const body = await this.call(options);

    const parsed = JSON.parse(body);

    const objects = [];

    for (const row of parsed.rows) {
      const object = {};
      const { fields } = parsed;

      for (let i = 0; i < fields.length; ++i) {
        object[fields[i].name] = row[i];
      }
      // @ts-ignore
      objects.push(object);
    }

    parsed.objects = objects;

    const page = new Page(parsed, 'objects');
    // @ts-ignore
    page.fields = parsed.fields;
    // @ts-ignore
    page.columns = parsed.columns;

    return page;
  }

  async queryRecords({ q }) {
    try {
      const data = await this.run({ q });

      for (const object of data.objects) {
        if (Object.prototype.hasOwnProperty.call(object, 'form_values')) {
          object.form_values = JSON.parse(object.form_values);
        }
      }

      return data.objects;
    } catch (error) {
      if (!isMissingGpsDeviceCaptureColumnError(error)) {
        throw error;
      }

      const patchedQuery = removeGpsDeviceCaptureProjection(q);

      if (patchedQuery === q) {
        throw error;
      }

      const data = await this.run({ q: patchedQuery });

      for (const object of data.objects) {
        if (Object.prototype.hasOwnProperty.call(object, 'form_values')) {
          object.form_values = JSON.parse(object.form_values);
        }
      }

      return data.objects;
    }
  }

  resourceName;
  resourcesName;
}
